import { fraseDaRecusa } from 'dashboard/helper/recusaDoAcesso';

// ACESSO-01 (L9a): a frase de uma falha da gestão de papéis e grupos, para a tela mostrar.
//
// - A recusa do acesso (403 `escopo_ausente`, `concessao_recusada`...) traz a frase do servidor (`fraseDaRecusa`).
// - O 422 traz a frase dele: em `error` o `em_uso` e o `modelo_so_leitura`, e em `message` o registro inválido (o nome
//   repetido, o grupo sem escopo), que o `render_record_invalid` monta no idioma da pessoa.
// - O resto (o 404, o 500, a rede) fica com a frase da tela: o `error` deles é texto para quem depura.
export const fraseDoErro = (erro, daTela) => {
  const recusa = fraseDaRecusa(erro);
  if (recusa) return recusa;

  const { status, data } = erro?.response || {};
  if (status === 422) return data?.error || data?.message || daTela;
  return daTela;
};
